import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { faqs } from '../data/content';
export function Faq() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section className="bg-ivory py-10 sm:py-14" aria-labelledby="faq-title" data-id="element-46" data-mp="1l9fsdcfv0m8f">
      <div className="mx-auto max-w-3xl px-5 sm:px-8" data-id="element-47" data-mp="1geimufhsgv0a">
        <h2 id="faq-title" className="text-center font-display text-[24px] font-semibold uppercase tracking-tightish text-navy-deep sm:text-3xl" data-id="element-48" data-mp="2e0pq9m2cwhb2">
          Questions, answered
        </h2>

        <ul className="mt-4 divide-y divide-navy/10 overflow-hidden rounded-xl border border-navy/10 bg-ivory-light sm:mt-6" data-id="element-49" data-mp="240yulh227w9e">
          {faqs.map((faq, index) => {
          const isOpen = openIndex === index;
          return <li key={faq.question} data-id="element-50" data-mp="sl0it5fhyw4h" data-mpi={index}>
                <button type="button" onClick={() => setOpenIndex(isOpen ? null : index)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-3 px-4 py-3.5 text-left transition-colors duration-150 ease-out hover:bg-ivory sm:px-5" data-id="element-51" data-mp="nniddp0ouz18">
                  <span className="text-[13.5px] font-semibold leading-snug text-navy-deep sm:text-base" data-id="element-52" data-mp="fjibrlhan0mi">
                    {faq.question}
                  </span>
                  {isOpen ? <MinusIcon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-53" data-mp="6q59hsxcamnr" /> : <PlusIcon className="h-4 w-4 shrink-0 text-teal" aria-hidden="true" data-id="element-54" data-mp="bjzq2nhnelim" />}
                </button>
                <AnimatePresence initial={false} data-id="element-55" data-mp="1rtzni71oc5j">
                  {isOpen ? <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} className="overflow-hidden" data-id="element-56" data-mp="3jy8b9ahuca0r">
                      <p className="px-4 pb-4 text-[13px] leading-snug text-navy-soft sm:px-5 sm:text-[15px]" data-id="element-57" data-mp="1potdwkehv35a">
                        {faq.answer}
                      </p>
                    </motion.div> : null}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}